<template>  
    <section>
		<div class="logo"></div>
		<p class="text">{{message}}</p>
		<div class="home-order">
            <span class="order" @click='leftClick' v-if='flag=="refund"'>查看退款</span>
			<span class="order" @click='leftClick' v-else-if='flag=="success"'>立即下单</span>
			<span class="order" @click='leftClick' v-else>查看订单</span>
			<span class="home" @click="rightClick">{{rightMsg}}</span>
		</div>
    </section>
</template>

<script>
    import CommonHeader from '@/components/CommonHeader'
    import utils from '@/assets/jslibs/utils'
    export default {
        name: 'index',
		data(){
			return{
				message:"支付成功",
                rightMsg:"返回首页",
                role:this.$route.query.role,
				flag:this.$route.query.flag,
				order_uuid:this.$route.query.order_uuid,
				isMobile:utils.isMobile(),
			}
		},
        components: {
            CommonHeader,
        },
		
		beforeCreate(){
			if(this.$route.query.role && this.$route.query.role=="user"){
				sessionStorage.setItem("roleType","customer")
			}else{
				sessionStorage.removeItem("roleType");
			}
            
            //清除用户下单时的信息回填，用户填写信息只在用户下单时存在
            sessionStorage.removeItem("params");
            sessionStorage.removeItem("newOrder");
            sessionStorage.removeItem("placeOrderId");  
		},
	
        created(){
            if(this.flag){
                if(this.flag=="dispatch"){
                	this.message = "派单成功";
                    this.rightMsg = "返回列表"
                }else if(this.flag=="refund"){
                	this.message = "退款成功";
                    this.rightMsg = "返回列表"
                }else if(this.flag=="refusalReject"){
                	this.message = "已拒绝驳回，完成订单成功";
                    this.rightMsg = "返回列表"
                }else if(this.flag=="admin"){//管理员下单
                	this.message = "下单成功";
                    this.rightMsg = "返回列表"
                }else if(this.flag=="success"){
                	this.message = "订单已完成";
                    this.rightMsg = "返回列表"
                }
            }
        },
        
        mounted(){
           document.title = "结果页"
        },
        
        methods: {
            //查看订单
            leftClick(){
                if(this.flag){
                    if(this.flag=="dispatch" || this.flag=="admin" || this.flag=="refund" || this.flag=="refusalReject"){
                        this.$router.push({path:'./orderdetail-admin',query:{order_uuid:this.order_uuid}})
                    }
                    if(this.flag=="refund"){
                        this.$router.push({path:'./refund-detail',query:{order_uuid:this.order_uuid,refund:"admin",backurl:location.href}})
                    }
					else if(this.flag=="success"){
						sessionStorage.setItem("peg",1);
						sessionStorage.setItem("stamp","placeOrder");
						this.$router.push({path:'./index'})
					}
                }
            },
            
            //返回列表,返回首页
            rightClick(){
                if(this.flag){
                    if(this.flag=="dispatch" || this.flag=="admin" || this.flag=="refund" || this.flag=="refusalReject"){
                        this.$router.push({path:'./myorder-admin'})
                    }
					else if(this.flag=="success"){
						sessionStorage.setItem("peg",2);
						sessionStorage.setItem("stamp","order");
						this.$router.push({path:'./index'})	
					}
                }
            }
        }
    }
</script>

<style lang='less' scoped>
	@import '~@/assets/styles/variable.less';
	@import '~@/assets/styles/handleMethods.less';
	@import '~@/assets/styles/reset.css';

    section,body{font-family:PingFangSC-Regular,PingFang SC;font-weight:400;background: #fff}
    .logo{width: 90px;height: 90px;margin: 0 auto;margin-top: 33px;background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size: cover}
	.text{color:rgba(20,20,20,1);font-size: 18px;margin-top: 16.5px;text-align:center}
	.money{text-align:center;font-size:23px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:rgba(20,20,20,1);}
	.menber-discount{color: #C1C1C1;font-size: 14px;text-align: center;margin-top: 6px;}
	.menber-discount span{color:#FF8630;font-size: 14px;padding-left: 10px;}
	.home-order{overflow: hidden;width: 220px;margin: 0 auto;margin-top: 22px;}
	.order{color: rgba(102,102,102,1);font-size: 15px;float: left;}
	.home{color: rgba(102,102,102,1);font-size: 15px;float: right;}
	
	.notice-wrap{color:rgba(51,51,51,1);font-size: 17px;flex: 1;width: 228px;margin: 0 auto;margin-top: 100px;}
	.notice-on{display: inline-block;margin-right: 50px}
	.notice{width: 50px;height:52px;display: inline-block;vertical-align: middle;}
	.on{background: url(../../assets/images/personal/pic_mine_on.png) no-repeat center center;background-size: 50px;}
	.off{background: url(../../assets/images/personal/pic_mine_off.png) no-repeat center center;background-size: 50px;}
	
	.tips-wrap{margin-top: 48px;font-size:14px;color:rgba(193,193,193,1);text-align: center;}
	.tips-wrap .tips{padding-left:18px;display: inline-block;background: url(../../assets/images/order-manage/ic_question.png) no-repeat left center;background-size: 14px;}

	.btn-wrap{display: flex;margin: 0 48px;align-items: center;justify-content: space-between;margin-top: 27px;}
	.btn-wrap .go-order{width:130px;height:34px;line-height: 34px;background:rgba(65,132,244,0.1);border-radius:4px;border:1px solid rgba(65,132,244,0.5);text-align: center;color:rgba(65,132,244,1);font-size: 14px;}
	.btn-wrap .look-order{width:130px;height:34px;line-height: 34px;background:rgba(102,102,102,0.06);border-radius:4px;border:1px solid rgba(193,193,193,1);text-align: center;color:rgba(51,51,51,1);font-size: 14px;}
</style>
